import clsx from "clsx";
import { startCase } from "lodash";

const PetGender: React.FC<{ gender: string; className?: string }> = (props) => {
  return props?.gender === null ? (
    <span className="text-xs text-red-500"> No Gender </span>
  ) : (
    <span className={clsx(props?.className)}>{props?.gender ? startCase(props?.gender?.toLowerCase()) : "Other"}</span>
  );
};

export default PetGender;
